import React from "react";

function ArrowIcon(props: { className: string }) {
  return (
    <svg viewBox="0 0 16 16" className={props.className}>
      <path d="m6.47 4.29 3.54 3.53c.1.1.1.26 0 .36L6.47 11.7a.75.75 0 1 0 1.06 1.06l3.54-3.53c.68-.69.68-1.8 0-2.48L7.53 3.23a.75.75 0 0 0-1.06 1.06z"></path>
    </svg>
  );
}

export { ArrowIcon };
